import type { XRayViewId } from '@/api/xrays';
import { createStudy } from '@/views/case-settings/api/createStudy';
import { useVersion } from '@/stores/version';

export type XRayFile = {
    view: XRayViewId;
    file: File;
};

export async function createXRayStudy(caseId: number, files: XRayFile[]): Promise<string> {
    return await createStudy(caseId, {
        name: 'drag-n-drop upload (XRay)',
        source_modality: 'xray',
        series: '',
        file_count: files.length,
        web_component_version: useVersion().webComponentVersion,
    });
}
